import lazyLoading from './lazyLoading'

export default {
  name: 'support',
  meta: {
    expanded: false,
    title: 'Asistencia',
    iconClass: 'vuestic-icon vuestic-icon-comments'
  },
  children: [
    {
      name: 'supportChat',
      path: '/support-chat',
      component: lazyLoading('support/Main'),
      meta: {
        title: 'Chat de Soporte'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('support/ChatList'),
          meta: {
            title: 'Chat de Soporte'
          }
        },
        {
          path: ':supportId',
          component: lazyLoading('support/ChatView'),
          props: true,
          meta: {
            title: 'Chat de Soporte'
          }
        },
      ]
    },
    {
      name: 'supportField',
      path: '/support-field',
      component: lazyLoading('support/Main'),
      meta: {
        title: 'Campos de Ayuda'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('support/FieldList'),
          meta: {
            title: 'Campos de Ayuda'
          }
        },
        {
          path: 'new',
          component: lazyLoading('support/FieldView'),
          props: true,
          meta: {
            title: 'Campos de Ayuda'
          }
        },
        {
          path: ':suppordFieldId',
          component: lazyLoading('support/FieldView'),
          props: true,
          meta: {
            title: 'Campos de Ayuda'
          }
        },
      ]
    },
    {
      name: 'supportInfo',
      path: '/support-info',
      component: lazyLoading('support/Main'),
      meta: {
        title: 'Información de Soporte'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('support/InfoList'),
          meta: {
            title: 'Información de Soporte'
          }
        },
        {
          path: 'new',
          component: lazyLoading('support/InfoView'),
          props: true,
          meta: {
            title: 'Información de Soporte'
          }
        },
        {
          path: ':suppordInfodId',
          component: lazyLoading('support/InfoView'),
          props: true,
          meta: {
            title: 'Información de Soporte'
          }
        },
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/support.js